import { TruncateString } from '../../../Public/Functions/TruncateString';
import { ButtonUpdate } from '../../Form/Buttons/ButtonUpdate';
import { FormDelete } from '../../Form/FormDelete';

export const Characters = (props) => {
    const { entity, datas } = props;
    return (
        <div className="admin-list">
            <div className="title">
                <div>{`ADMIN: ${entity} (${datas.length})`}</div>
            </div>
            <div className="thead">
                <div className="block-rows">
                    <div className="id">id</div>
                    <div className="name">name</div>
                    <div className="item">category</div>
                    <div className="item">origin</div>
                    <div className="item">family</div>
                </div>
                <div className="block-buttons"></div>
            </div>
            {datas.map((el, i) => {
                let name = TruncateString(el.name, 30);
                let oname = TruncateString(el.oname, 30);
                return (
                    <div key={`i-${i}`} className="rows">
                        <div className="block-rows">
                            <div className="id">{i + 1}</div>
                            <div className="name">{name}<span className="id">({el.id})</span></div>
                            <div className="item">{el.cname}</div>
                            <div className="item">{oname}</div>
                            <div className="item">{el.fname}</div>
                        </div>
                        <div className="block-buttons">
                            <ButtonUpdate entity={entity} id={el.id} />
                            <FormDelete entity={entity} id={el.id} />
                        </div>
                    </div>
                )
            })}
        </div>
    )
} 